module.exports = __webpack_public_path__ + "img/drone-nieuwegein.f2d59699.jpg";